import styles from './_need_help_box.scss?inline';
import { addGlobalStylesToShadowRoot } from 'music/app/javascript/src/v3/custom_elements/shared/utils/custom_elements.js';

export default class UaNeedHelpBox extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
  }

  /**
   * @return {Object} - mapping of need help variant names to icon names.
   */
  get icons() {
    return Object.freeze({
      'visit-store': 'shopping-cart',
      'guided-tour': 'route',
      'chat-agent': 'annotation-dots',
      'school': 'graduation-hat',
      'redeem-code': 'passcode',
      'enroll-course': 'book-open',
      'about-vhl': 'book-open',
    });
  }

  /**
   * @return {String} - HTML template for component.
   */
  get template() {
    const variant = this.getAttribute('variant');
    const iconName = this.icons[variant];

    return `
      <div class="m4-need-help-item">
        <div class="m4-need-help__icon-wrapper" part="icon-wrapper">
          <sl-icon name="${iconName}" library="default" class="m4-need-help__icon" part="icon">
          </sl-icon>
        </div>
        <slot></slot>
      </div>
      <style>
        ${styles}
      </style>`;
  }

  /**
   * Initialize component when added to document.
   */
  connectedCallback() {
    addGlobalStylesToShadowRoot(this.shadowRoot);
    this.shadowRoot.innerHTML = this.template;
  }
}
